@if (!sender) {
  <h1>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_CARD.INPUT_NOT_PROVIDED' | translate }}</h1>
}
@if (senderInfo$ | glxyAsyncStatus | async; as senderInfo) {
  @switch (senderInfo.status) {
    @case ('loaded') {
      <email-sender-info-form
        [sender]="sender"
        [senderInfo]="senderInfo.value"
        [domainOverride]="domainOverride"
        (domainChangeRequested)="setDomain($event)"
        (invalidDomainChangeRequested)="invalidDomainChangeRequested.emit($event)"
        (authorizeRequested)="handleAuthorizeRequested()"
      ></email-sender-info-form>
    }
    @case ('loading') {
      <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
    }
    @case ('error') {
      <glxy-empty-state>
        <p>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_CARD.LOADING_ERROR' | translate }}</p>
        <glxy-empty-state-actions>
          <button mat-flat-button color="primary" (click)="reInitializeObservables()">
            {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_CARD.TRY_AGAIN' | translate }}
          </button>
        </glxy-empty-state-actions>
      </glxy-empty-state>
    }
  }
}
